export const RebateTier = Object.freeze({
  BASE_TIER: 'BASE_TIER',
  TIER_1: 'TIER_1',
  TIER_2: 'TIER_2',
  TIER_3: 'TIER_3',
  NONE: 'none',
});
